import { makeStyles } from "@material-ui/styles";

const matchPlayersStyles = makeStyles((theme) => ({
	players: {
		width: "100%",
		blockSize: "56px",
		// eslint-disable-next-line quotes
		'& .MuiAutocomplete-inputRoot[class*="MuiOutlinedInput-root"]': {
			overflow: "hidden"
		},
		"& .MuiInputAdornment-positionStart": {
			color: theme.palette.primary.main
		},
		"& input": {
			display: ({ twoSelected }) => twoSelected && "none"
		},

		[theme.breakpoints.only("sm")]: {
			marginBottom: ({ twoSelected }) => twoSelected && theme.spacing(4)
		},
		[theme.breakpoints.only("xs")]: {
			marginBottom: ({ twoSelected }) => twoSelected && theme.spacing(5)
		}
	},
	chip: {
		maxWidth: "140px",
		margin: theme.spacing(0.25)
	}
}));

export default matchPlayersStyles;
